import { store } from "../../store";
import { logoutWithRedirect } from "../authentication/authenticationSlice";

export function getSubscriptionDetails() {
  return new Promise((resolve, reject) => {
    fetch("/api/subscriptionDetails", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "getSubscriptionDetails.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function downsellSubscription() {
  return new Promise((resolve, reject) => {
    fetch("/api/downsellSubscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "downsellSubscription.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        console.log("downsellSubscription data", data);
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function cancelSubscription() {
  return new Promise((resolve, reject) => {
    fetch("/api/cancelSubscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "cancelSubscription.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function undoCancelSubscription() {
  return new Promise((resolve, reject) => {
    fetch("/api/undoCancelSubscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        subscriptionId:
          store.getState().subscription.primarySubscription?.subscriptionId,
      }),
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "undoCancelSubscription.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function retryPayment({
  email,
  IgnoreBillingDateCheck,
}: {
  email?: string | undefined;
  IgnoreBillingDateCheck?: boolean | undefined;
}) {
  return new Promise((resolve, reject) => {
    fetch("/api/retryPayment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body:
        email && IgnoreBillingDateCheck
          ? JSON.stringify({ email, IgnoreBillingDateCheck })
          : null,
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "retryPayment.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function pauseSubscription() {
  return new Promise((resolve, reject) => {
    fetch("/api/pauseSubscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "pauseSubscription.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function unPauseSubscription() {
  return new Promise((resolve, reject) => {
    fetch("/api/unPauseSubscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "unPauseSubscription.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function addNoteCancelFeedback({ content }: { content: string }) {
  return new Promise((resolve, reject) => {
    fetch("/api/addNoteCancelFeedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ content }),
    })
      .then(async response => {
        if (response.status === 401) {
          const body = await response.json();
          store.dispatch(
            logoutWithRedirect({
              location: "addNoteCancelFeedback.authenticate",
              logError: body.message,
            }),
          );
          reject({ message: "No token, authorization denied" });
        } else {
          return response.json();
        }
      })
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
